import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimOnFocusout]',
  standalone: false
})
export class TrimOnFocusoutDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('blur')
  onBlur(): void {
    const control = this.ngControl?.control;
    const value = control?.value;

    if (typeof value !== 'string') {
      return;
    }

    const trimmedValue = value.trim();

    if (trimmedValue !== value) {
      control?.setValue(trimmedValue);
    }
  }
}